const LockIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="44"
      viewBox="0 0 54 54"
      width="44"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M38.8535 18.5926V15.5384C38.8535 9.38307 33.8493 4.37891 27.694 4.37891C21.5386 4.37891 16.5345 9.38307 16.5345 15.5384V18.5926C11.9767 19.2035 9.48633 22.2107 9.48633 27.2853V41.3815C9.48633 47.067 12.611 50.1917 18.2965 50.1917H37.0915C42.777 50.1917 45.9016 47.067 45.9016 41.3815V27.2853C45.9016 22.2341 43.4113 19.2035 38.8535 18.5926ZM27.694 7.90297C31.8994 7.90297 35.3294 11.3331 35.3294 15.5384V18.4751H20.0585V15.5384C20.0585 11.3331 23.4886 7.90297 27.694 7.90297ZM42.3776 41.3815C42.3776 45.0936 40.8035 46.6676 37.0915 46.6676H18.2965C14.5845 46.6676 13.0104 45.0936 13.0104 41.3815V27.2853C13.0104 23.5733 14.5845 21.9992 18.2965 21.9992H37.0915C40.8035 21.9992 42.3776 23.5733 42.3776 27.2853V41.3815ZM30.6777 31.9841C30.6777 32.9473 30.1843 33.7696 29.456 34.3099V39.0322C29.456 39.9954 28.6572 40.7942 27.694 40.7942C26.7307 40.7942 25.9319 39.9954 25.9319 39.0322V34.2394C25.2506 33.6991 24.7808 32.9003 24.7808 31.9841C24.7808 30.363 26.0729 29.0473 27.7175 29.0473C29.3385 29.0473 30.6542 30.363 30.6542 31.9841H30.6777Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LockIcon;
